import { Grid } from '@mui/material';
import { PqrReceivedThroughDataProps } from './props';
import { usePqrReceivedThroughData } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const SuptypeDPData = (props: PqrReceivedThroughDataProps) => {
    const { formik, types } = usePqrReceivedThroughData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <AutocompleteField
                    data={formatParams(types)}
                    label="Tipo PQR"
                    name="parent"
                    size="small"
                    required
                    disabled={types.length === 0}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.parent}
                    errors={formik.errors.parent}
                    value={formik.values.parent}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('parent', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="extra2"
                    size="small"
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.extra2}
                    errors={formik.errors.extra2}
                    value={formik.values.extra2}
                    onChange={formik.handleChange}
                    required={!!props?.data?.id}
                />
            </Grid>
        </Grid>
    );
};
